import { Icon } from "@sellar-io/components";
import { pluralize } from "@sellar-io/common";

export const UnifiedCheckoutRemainingBasketAlert = ({
  count,
  itemCount,
  onClick,
}: {
  count: number;
  itemCount: number;
  onClick: () => void;
}) => (
  <button
    type="button"
    className="mt-2 flex items-center justify-between rounded-lg border border-[#D1A7E9] bg-[#E8D3F4]/40 p-3 text-left text-sm text-[#8C23C7]"
    onClick={onClick}
  >
    <span className="flex items-center gap-2">
      <Icon icon="CART" size={0.7} />
      <span className="flex flex-col">
        <strong className="font-semibold">
          {count} more {pluralize("basket", count)} ready for next week
        </strong>
        <span className="text-xs text-zinc-600">
          {itemCount} {pluralize("item", itemCount)}
        </span>
      </span>
    </span>
    <span className="flex items-center gap-1 font-semibold">
      Continue ordering
      <Icon icon="CHEVRON_RIGHT" size={0.7} />
    </span>
  </button>
);
